<template>
  <div>
    <currentpage :page="'SERVICES'" :thispage="'Our Services'"></currentpage>
    <!-- service start -->
    <section id="vaccinations">
        <b-container>
            <b-row>
                <b-col>
                    <h3>Vaccinations</h3>
                    <p>
                    Vaccinations for the following diseases are available at Akai House Clinic:
                    Chicken Pox (Varilrix)
                    Diptheria, Tetanus &amp; Pertussis (DTaP)
                    Hepatitis A
                    Hepatitis B
                    Human Papilloma Virus (HPV)
                    Meningitis (Mencevax)
                    MMR (Measles Mumps &amp; Rubella)
                    Pentavalent Vaccine (Haemophilus influenzae type B, whooping cough, tetanus, hepatitis B and diphtheria)
                    Pneumococal Conjugate Vaccine (PCV13 and PPV23)
                    Polio (Oral Polio Vaccine)
                    PPD (for Tuberculin Skin Testing/Mantoux)
                    Rabies (ARV)
                    Rotavirus (Rotarix)
                    Tetanus Diptheria (Td)
                    Tetanus Toxoid
                    Typhoid
                    </p>
                </b-col>
            </b-row>
        </b-container>
    </section>
    <!-- <section id="services" class="py-5 my-5">
        <b-container>
            <div class="section-title">
                <b-row>
                    <b-col md="8" offset-md="2" class="text-center">
                        <h2>Our <span>Services</span></h2>
                        <div class="border-center"></div>
                        <p class="py-4">Repellendus error placeat numquam doloribus perferendis
                          consequatur maxime molestiae soluta Corporis quidem quaerat
                          accusantium omnis repudiandae nulla recusandae</p>
                    </b-col>
                </b-row>
            </div>
            <div class="section-content">
                <b-row>
                    <b-col sm="6" md="4">
                        <div class="text-center service-item style-3 py-5 px-3">
                            <span class="flaticon-first-aid-kit"></span>
                            <h4 class="py-2">GP &amp; Specialist Consultations</h4>
                            <div class="border-center"></div>
                            <p class="py-2">  Provide direct support to an individual, family or community by paying medical expenses for service.</p>
                            <p>Doctor: Thomas Ntow</p>
                            <p>Available Hours: 4am - 10pm</p>
                        </div>
                    </b-col>
                    <b-col sm="6" md="4">
                        <div class="text-center service-item style-3 py-5 px-3">
                            <span class="flaticon-dna"></span>
                            <h4 class="py-2">Immigration Medicals</h4>
                            <div class="border-center"></div>
                            <p class="py-2">  Provide direct support to an individual, family or community by paying medical expenses for service.</p>
                            <p>Doctor: Thomas Ntow</p>
                            <p>Available Hours: 4am - 10pm</p>
                        </div>
                    </b-col>
                    <b-col sm="6" md="4">
                        <div class="text-center service-item style-3 py-5 px-3">
                            <span class="flaticon-respiratory-system"></span>
                            <h4 class="py-2">AkaiLab - Laboratory</h4>
                            <div class="border-center"></div>
                            <p class="py-2">  Provide direct support to an individual, family or community by paying medical expenses for service.</p>
                            <p>Doctor: Thomas Ntow</p>
                            <p>Available Hours: 4am - 10pm</p>
                        </div>
                    </b-col>
                </b-row>
               <b-row class="mt-4">
                    <b-col sm="6" md="4">
                        <div class="text-center service-item style-3 py-5 px-3">
                            <span class="flaticon-medical"></span>
                            <h4 class="py-2">AkaiScan - Imaging</h4>
                            <div class="border-center"></div>
                            <p class="py-2">  Provide direct support to an individual, family or community by paying.</p>
                            <p>Doctor: Thomas Ntow</p>
                            <p>Available Hours: 4am - 10pm</p>
                        </div>
                    </b-col>
                    <b-col sm="6" md="4">
                        <div class="text-center service-item style-3 py-5 px-3">
                            <span class="flaticon-antibiotic"></span>
                            <h4 class="py-2">AkaiVax - Vaccination</h4>
                            <div class="border-center"></div>
                            <p class="py-2">  Provide direct support to an individual, family or community by paying medical expenses for service.</p>
                            <p>Doctor: Thomas Ntow</p>
                            <p>Available Hours: 4am - 10pm</p>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </section> -->
    <!-- service end -->
  </div>
</template>

<script>
export default {
  data: function () {
    return {

    }
  }
}
</script>

<style scoped>

</style>
